import React, { FC, useCallback, useMemo } from 'react';
import Stack from '@mui/material/Stack';
import { Grid, IconButton, Typography } from '@mui/material';
import DeleteIcon from 'components/Icons/deleteIcon';
import EditIconPencilBottomLine from 'components/Icons/editIconPencilBottomLine';
import {
  CountCnt,
  StepCounter,
} from 'components/AllDialogs/checklistVisibility/styled';
import FormulaIcon from 'components/Icons/formulaIcon';
import {
  getFormulaView,
  validateFormula,
} from '../CalculationDialog/utils/utils';

interface IProps {
  onEdit?(): void;
  checkListItems: any;
  field: any;
  styles?: any;
  allowEdit?: boolean;
}

const defaultVlues = {
  description: '',
  unit: null,
  type: 'Sum',
  items: [],
  itemValue: null,
};
const FormulaDescription: FC<IProps> = (props) => {
  const { field, checkListItems, allowEdit = false, onEdit, styles } = props;

  const items = field?.options?.items || [];
  const operator = field?.options?.operator || null;
  const validateItems = useMemo(() => {
    return validateFormula(items, checkListItems) || false;
  }, [items, checkListItems]);

  const formulaView = useMemo(() => {
    if (!validateItems) {
      // Check specifically if the issue is having fewer than 2 items
      if (!items || items.length < 2) {
        return (
          <Typography fontSize={'13px'} fontWeight={600} color={'#D32F2F'}>
            At least 2 items required for calculation.
          </Typography>
        );
      }

      // Default error for other validation issues
      return (
        <Typography fontSize={'13px'} fontWeight={600} color={'#D32F2F'}>
          Invalid Calculation – Missing or incompatible steps.
        </Typography>
      );
    }
    return getFormulaView({ ...field, items, operator }, checkListItems);
  }, [items, checkListItems, validateItems]);
  return (
    <Stack style={styles}>
      <Stack
        direction={'row'}
        width="100%"
        gap={'8px'}
        sx={{
          padding: '10px 16px',
          borderRadius: '8px',
          background: validateItems
            ? 'linear-gradient(90deg, rgba(0, 210, 255, 0.1) 0%, rgba(58, 123, 213, 0.1) 100%)'
            : '#FFEBEE',
        }}
      >
        <FormulaIcon
          sx={{
            fontSize: '20px',
            color: validateItems ? '#0288D1' : '#D32F2F',
          }}
        />
        {formulaView}
        {!validateItems && allowEdit && (
          <Typography
            sx={{
              color: '#4E48FA',
              fontSize: '13px',
              marginLeft: 'auto',
              fontWeight: 700,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Fix formula
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default FormulaDescription;
